import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { AppComponent } from 'src/app/app.component';
import { IdiomaService } from '../../services/idioma.service';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit{
  langages: string[];
  deferredPrompt:any;
  phone = environment.phone;
  email = environment.email;
  socialMedias = environment.socialMedia;
  constructor(
    private navCtrl: NavController,
    private idiomaService: IdiomaService,
    ) {}

  async ngOnInit() {
    this.langages = this.idiomaService.langages;
  }

  async changeLanguage(ev) {
    const valueLang = ev.detail.value;
    await this.idiomaService.changeLangage(valueLang);
  }

  redirectTo(url: string) {
    let query:NavigationExtras;
    this.navCtrl.navigateForward(url, query);
  }

  openSocial(type){
    if(type === 'email'){
      window.open(`mailto:${this.email}`, '_blank');
    }else{
      window.open(`https://wa.me/${this.phone}`, '_blank');
    }
  }
}
